import { APIUrls } from "../../Constants/ApiUrls";
import { AjaxService, IAPIRequest, IAPIResponse } from "../AjaxService";

const CaringController = {
  // fresh: dopo una modifica si rilegge dal server, senza la copia in cache
  GetCarings: async (callback?: (response: IAPIResponse) => void, fresh = false) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.CARINGS.CARINGS_GET;
    request.allowApiCache = !fresh;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  CreateCaring: async (
    patientId: number,
    userId: number,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.CARINGS.CARINGS_INSERT;
    request.method = "POST";
    request.payload = {
      patientId,
      userId,
    };
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  DeleteCaring: async (
    patientId: number,
    userId: number,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.CARINGS.CARINGS_DELETE;
    request.method = "DELETE";
    request.payload = {
      patientId,
      userId,
    };
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  UpdateCaring: async (
    id: number,
    patientId: number,
    userId: number,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.CARINGS.CARINGS_UPDATE;
    request.method = "PUT";
    request.payload = {
      id,
      patientId,
      userId,
    };
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
};

export default CaringController;
